module.exports = __webpack_public_path__ + "static/media/contentaccount.0feb31aa.png";